import { render, staticRenderFns } from "./TheTabTitle.vue?vue&type=template&id=33ebadce&"
import script from "./TheTabTitle.vue?vue&type=script&lang=js&"
export * from "./TheTabTitle.vue?vue&type=script&lang=js&"
import style0 from "./TheTabTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports